import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

// material ui
import Box from '@mui/material/Box'

// shared components
import PopupNotifications from 'components/shared/PopupNotifications'
import NotFound from 'components/shared/NotFound'
import AccountFooter from 'components/shared/AccountFooter'

// components for routes
import Login from 'components/login/Login'

// local components
import Banner from './Banner'

const LoginRoutes = ({ basename, headerMessage, notice, bhParam }) => (
  <BrowserRouter basename={basename}>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
      }}
    >
      <Banner headerMessage={headerMessage} />
      <PopupNotifications />
      <Box component='main' sx={{ flex: 1 }}>
        <Routes>
          <Route
            path='/'
            element={<Login notice={notice} bhParam={bhParam} />}
          />
          <Route path='*' component={NotFound} />
        </Routes>
      </Box>
      <AccountFooter />
    </Box>
  </BrowserRouter>
)

export default LoginRoutes
